import { Delete } from "@mui/icons-material"
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    MenuItem,
} from "@mui/material"
import { useState } from "react"
import { useDeleteSensorInstall } from "../../../api/SensorInstallApi"
import { useSnackbarStore } from "../../../components/Snackbar/Snackbar"
import { LabelAndText } from "../../../components/Typography/Typography"
import { SensorInstallInfo } from "../../../models/sensors/SensorInstallInfo"

interface DeleteSensorInstallMenuItemProp {
    sensorInstall: SensorInstallInfo
    closeMenu: () => void
}

export const DeleteSensorInstallMenuItem = (props: DeleteSensorInstallMenuItemProp) => {
    const [dialogOpen, setDialogOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const openSnackbar = useSnackbarStore((state) => state.handleOpen)
    const sensorInstall = props.sensorInstall

    const useSensorInstallMutation = useDeleteSensorInstall()

    return (
        <>
            <MenuItem onClick={() => setDialogOpen(true)}>
                <Delete /> Delete
            </MenuItem>
            <Dialog open={dialogOpen}>
                <DialogTitle>Delete Sensor Installation?</DialogTitle>
                <DialogContent>
                    <LabelAndText label="Sensor">
                        {sensorInstall.sensor.sensor_model} - {sensorInstall.sensor.serial_number}
                    </LabelAndText>
                    <LabelAndText label="File">{sensorInstall.file_name}</LabelAndText>
                    <LabelAndText label="Valid Start">{sensorInstall.valid_start}</LabelAndText>
                    <LabelAndText label="Valid End">{sensorInstall.valid_end ?? "Present"}</LabelAndText>

                    <DialogContentText sx={{ pt: 2 }}>
                        This will permanently delete the sensor installation and cannot be reversed.
                    </DialogContentText>
                    <DialogContentText>Are you sure?</DialogContentText>

                    {useSensorInstallMutation.isError && (
                        <Alert severity="error">
                            {errorMessage ?? "Unable to delete sensor installation! Unexpected error occurred"}
                        </Alert>
                    )}
                </DialogContent>
                <DialogActions sx={{ justifyContent: "space-between" }}>
                    <Button
                        color={"error"}
                        onClick={async () => {
                            if (sensorInstall.id == null) {
                                throw new Error(`Unable to delete sensor installation, invalid id: ${sensorInstall.id}`)
                            }
                            await useSensorInstallMutation.mutateAsync(sensorInstall.id, {
                                onSuccess: async () => {
                                    setErrorMessage("")
                                    openSnackbar({
                                        message: `Deleted Sensor Installation with file ${sensorInstall.file_name}`,
                                        severity: "success",
                                    })
                                    props.closeMenu()
                                },
                                onError: (error) => {
                                    setErrorMessage(error.message)
                                },
                            })
                        }}
                    >
                        Delete
                    </Button>
                    <Button variant={"contained"} onClick={() => setDialogOpen(false)}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
